import { cn, Table } from "@kyan/ui";
import moment from "moment";

import { type RFQResponseState } from "#/services/kyan/kyan.types";
import { formatAddress } from "#/utils/formatAddress";
import { isBuy } from "#/utils/marketActionConverter";

import { type RfqEntry } from "../../../../Rfq.types";
import { RfqTable } from "../RfqTable/RfqTable";
import {
  immediateLayerColumns,
  innerTableColumns,
} from "./MultiLegTable.config";

export interface MultiLegTableProps {
  data: RFQResponseState[];
}
export const MultiLegTable: React.FC<MultiLegTableProps> = ({ data }) => {
  const list = data.map((response) => {
    const summary = response.legs.reduce(
      (acc, item) => ({
        ...acc,
        netPrice:
          (isBuy(item.direction) ? -1 : 1) * item.netPrice + acc.netPrice,
      }),
      {
        variant: "summary",
        instrument: "Summary",
        netPrice: 0,
        time: moment(response.timestamp).format("DD-MMM-h:mm"),
        responseId: response.responseId,
        taker: response.taker,
        response,
      },
    ) as RfqEntry;
    return {
      instrument: `Combo rfq #${formatAddress(response.responseId)}`,
      count: response.legs.length,
      subEntries: [
        ...response.legs.map((leg) => ({
          instrument: leg.instrumentName,
          side: leg.direction,
          price: leg.price,
          size: leg.size,
          time: moment(leg.timestamp).format("DD-MMM-h:mm"),
          netPrice: leg.price * leg.size,
        })),
        summary,
      ],
    };
  });

  return (
    <RfqTable
      data={list}
      variant="inner"
      shouldAutoExpand={false}
      columns={immediateLayerColumns}
      classes={{
        cellClassName: "h-8",
        wrapper: "leading-0",
      }}
    >
      {(row) => (
        <Table
          hideHeader
          columns={innerTableColumns}
          data={row.subEntries ?? []}
          classes={{
            row: ({ row: { count }, isRowOpen }) => {
              return cn("transition-colors", {
                "bg-buttonHover": isRowOpen && (count ?? 0) > 0,
              });
            },
            table: "border-0",
            tbody: "text-textPrimary",
          }}
        />
      )}
    </RfqTable>
  );
};
